import protobuf from "protobufjs";
import protoSchema from "./offers_list.proto?raw";

let root = null;

const loadRoot = () => {
    if (!root) {
        root = protobuf.parse(protoSchema).root;
    }

    return root;
};

const str = (value) => (value === null || value === undefined ? "" : String(value));

const safeJsonParse = (value, fallback) => {
    if (!value) return fallback;

    try {
        return JSON.parse(value);
    } catch (error) {
        return fallback;
    }
};

const toBytes = async (buffer) => {
    if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    if (typeof Blob !== "undefined" && buffer instanceof Blob) return new Uint8Array(await buffer.arrayBuffer());

    return null;
};

const decodeOffer = (raw = {}) => {
    const offerDetail = raw.offerDetail || {};
    const vendor = raw.vendor || {};

    const offer = {
        _id: str(raw.id),
        title: raw.title || "",
        description: raw.description || "",
        code: raw.code || "",
        dateStart: raw.dateStart || null,
        dateEnd: raw.dateEnd || null,
        offerOptions: Array.isArray(raw.offerOptions) ? raw.offerOptions : [],
        offerType: raw.offerType || "",
        cover: raw.cover || "",
        coverMobile: raw.coverMobile || "",
        activationLink: raw.activationLink || "",
        offerDetail: {
            termsOfUse: offerDetail.termsOfUse || "",
            ordRisPromo: offerDetail.ordRisPromo || "",
            howToActivate: offerDetail.howToActivate || "",
            miniDisc: offerDetail.miniDisc || "",
            showInputsInModal: !!offerDetail.showInputsInModal,
            smsProviderType: offerDetail.smsProviderType || "",
        },
        inputFields: Array.isArray(raw.inputFields)
            ? raw.inputFields.map((field) => ({
                  active: !!field.active,
                  isVerified: !!field.isVerified,
                  key: field.key || "",
                  placeholder: field.placeholder || "",
                  require: !!field.require,
                  sort: field.sort || 0,
                  type: field.type || "",
              }))
            : [],
        offerTypeCPC: raw.offerTypeCPC || "",
        ghostOffer: !!raw.ghostOffer,
        surveyId: raw.surveyId || null,
        addressId: raw.addressId || null,
        disclaimer: raw.disclaimer || "",
        sortNum: raw.sortNum || 0,
        ghostOfferConfig: safeJsonParse(raw.ghostOfferConfigJson, {}),
        geoObject: safeJsonParse(raw.geoObjectJson, {}),
        vendor: {
            _id: str(vendor.id),
            name: vendor.name || "",
            squareLogo: vendor.squareLogo || "",
            logoList: vendor.logoList || "",
            vendorInfo: safeJsonParse(vendor.vendorInfoJson, {}),
            categoriesIds: Array.isArray(vendor.categoriesIds) ? vendor.categoriesIds : [],
            category: Array.isArray(vendor.category) ? vendor.category : [],
        },
        vendorcategories: Array.isArray(raw.vendorCategories)
            ? raw.vendorCategories.map((category) => ({
                  _id: str(category.id),
                  title: category.title || "",
                  alias: category.alias || "",
              }))
            : [],
        recommendedOffers: Array.isArray(raw.recommendedOffers) ? raw.recommendedOffers : [],
        _ab_code: raw.abCode || "",
    };

    if (raw.recieved) {
        offer.recieved = !!raw.recieved;
    }

    if (Array.isArray(raw.sugmnt) && raw.sugmnt.length) {
        offer._sugmnt = raw.sugmnt;
    }

    return offer;
};

const decodePromo = (raw = {}) => ({
    _id: str(raw.id),
    code: raw.code || "",
    offerId: str(raw.offerId),
    activationLink: raw.activationLink || "",
});

const decodeAbM = (raw = []) =>
    raw.reduce((acc, entry) => {
        if (!entry?.key) return acc;
        acc[entry.key] = safeJsonParse(entry.value, entry.value);
        return acc;
    }, {});

const decodeOffersListResponse = async (buffer) => {
    const bytes = await toBytes(buffer);
    if (!bytes || bytes.byteLength === 0) {
        return { success: false, errorCode: 0, msg: "Empty proto buffer" };
    }

    const Response = loadRoot().lookupType("rispromo.offers_list.OffersListResponse");
    const message = Response.decode(bytes);
    const obj = Response.toObject(message, {
        arrays: true,
        defaults: true,
        longs: String,
    });

    return {
        success: true,
        data: {
            promo: Array.isArray(obj.promo) ? obj.promo.map(decodePromo) : [],
            offers: Array.isArray(obj.offers) ? obj.offers.map(decodeOffer) : [],
            _ab_m: decodeAbM(obj.abM),
        },
    };
};

export { decodeOffersListResponse };
